/** Namespace `staff` — bản gốc tiếng Việt. Khoá phẳng, tên camelCase; `{biến}` để chèn. */
export const staff = {
  loadFailed: "Không đọc được danh sách nhân viên.",
  inviteFailed: "Không cấp được tài khoản.",
  changeRoleFailed: "Không đổi được vai.",
  disableFailed: "Không khoá được nhân viên.",
  title: "Nhân viên",
  intro: "Hub không có đăng ký công khai — mọi tài khoản cấp từ đây, và chỉ vai chủ cấp được.",
  invite: "Cấp tài khoản",
  inviting: "Đang cấp…",
  tempPasswordFor: "Mật khẩu tạm cho {email} — hiện ĐÚNG MỘT LẦN",
  tempPasswordHint: "Chép lại ngay. Hub chỉ lưu bản băm, nên không tra lại được — không chép thì phải cấp lại.",
  expiresAt: " Hết hạn {at}.",
  copiedIt: "Tôi đã chép lại",
  email: "Email",
  displayName: "Tên hiển thị",
  role: "Vai",
  "col.email": "Email",
  "col.name": "Tên",
  "col.role": "Vai",
  "col.membership": "Tư cách trong hub",
  "col.createdAt": "Tạo lúc",
  cannotChangeOwnRole: "Không tự đổi vai của chính mình",
  disableTitle: "Chỉ khoá quyền vào hub — tài khoản ở các app khác không đổi",
  disable: "Khoá khỏi hub",
  footnoteBefore: "« Khoá khỏi hub » chỉ thu hồi tư cách thành viên trong workspace nội bộ của hub. Danh tính chung (",
  footnoteMiddle: ") và tài khoản ở các app khác ",
  footnoteStrong: "không",
  footnoteAfter: " bị đụng tới.",
  "status.disabled": "Đã khoá khỏi hub",
  "status.mustChange": "Chờ đổi mật khẩu tạm",
  "status.active": "Đang hoạt động",
} as const;
